import React from 'react';
import { BsCurrencyExchange } from 'react-icons/bs';
import { NavSubmenuDivider, NavSubmenuLabel } from './navMenuLayout';
import SidebarFlyoutNavRow from './SidebarFlyoutNavRow';
import { ADMIN_FLYOUT_IDS } from './SidebarFlyoutContext';
import {
  buildFinanceFlyoutItems,
  FINANCE_CHILD_ROUTES,
} from './finance/financeNavConfig';

function FinanceFlyoutRow({
  SubMenuItem,
  hasMenuAccess,
  closeMobileSidebar,
  indentClass = 'ps-5',
}) {
  const items = buildFinanceFlyoutItems(hasMenuAccess);
  if (items.length === 0) return null;

  return (
    <SidebarFlyoutNavRow
      flyoutId={ADMIN_FLYOUT_IDS.finance}
      label="Finance"
      flyoutTitle="Finance"
      items={items}
      SubMenuItem={SubMenuItem}
      closeMobileSidebar={closeMobileSidebar}
      indentClass={indentClass}
      flyoutWidth={360}
      alwaysFlyout
    />
  );
}

function FinanceNavContent({
  SubMenuItem,
  hasMenuAccess,
}) {
  return (
    <>
      {(hasMenuAccess('/finance/petty-cash')
        || hasMenuAccess('/finance/petty-cash/new')
        || hasMenuAccess('/finance/petty-cash/funds')
        || hasMenuAccess('/finance/petty-cash/reports')
        || hasMenuAccess('/finance/petty-cash/reports/monthly')) && (
        <>
          <NavSubmenuLabel>Petty Cash</NavSubmenuLabel>
          {hasMenuAccess('/finance/petty-cash') && <SubMenuItem to="/finance/petty-cash">Petty Cash Dashboard</SubMenuItem>}
          {hasMenuAccess('/finance/petty-cash/new') && <SubMenuItem to="/finance/petty-cash/new">New Petty Cash</SubMenuItem>}
          {hasMenuAccess('/finance/petty-cash/funds') && <SubMenuItem to="/finance/petty-cash/funds">Petty Cash Funds</SubMenuItem>}
          {hasMenuAccess('/finance/petty-cash/reports') && <SubMenuItem to="/finance/petty-cash/reports">Petty Cash Reports</SubMenuItem>}
          {hasMenuAccess('/finance/petty-cash/reports/monthly') && (
            <SubMenuItem to="/finance/petty-cash/reports/monthly">Monthly Report</SubMenuItem>
          )}
          <NavSubmenuDivider />
        </>
      )}
      {(hasMenuAccess('/finance/corporate-expenses') || hasMenuAccess('/finance/corporate-expenses/new')) && (
        <>
          <NavSubmenuLabel>Corporate Expenses</NavSubmenuLabel>
          {hasMenuAccess('/finance/corporate-expenses') && (
            <SubMenuItem to="/finance/corporate-expenses">Expenses List</SubMenuItem>
          )}
          {hasMenuAccess('/finance/corporate-expenses/new') && (
            <SubMenuItem to="/finance/corporate-expenses/new">New Expense</SubMenuItem>
          )}
          <NavSubmenuDivider />
        </>
      )}
      {(hasMenuAccess('/finance/company-assets') || hasMenuAccess('/finance/company-assets/new')) && (
        <>
          <NavSubmenuLabel>Company assets</NavSubmenuLabel>
          {hasMenuAccess('/finance/company-assets') && (
            <SubMenuItem to="/finance/company-assets">Company assets (recovery)</SubMenuItem>
          )}
          {hasMenuAccess('/finance/company-assets/new') && (
            <SubMenuItem to="/finance/company-assets/new">New company asset</SubMenuItem>
          )}
          <NavSubmenuDivider />
        </>
      )}
      {(hasMenuAccess('/finance/coa') || hasMenuAccess('/finance/exchange-rates')) && (
        <>
          <NavSubmenuLabel>Accounting</NavSubmenuLabel>
          {hasMenuAccess('/finance/coa') && <SubMenuItem to="/finance/coa">Chart of Accounts</SubMenuItem>}
          {hasMenuAccess('/finance/exchange-rates') && (
            <SubMenuItem to="/finance/exchange-rates">Exchange Rates</SubMenuItem>
          )}
        </>
      )}
    </>
  );
}

/**
 * Finance block for the desktop sidebar.
 * Under Administration: single flyout row (Drilling → Budget / Catering pattern).
 */
export default function FinanceNavSection({
  MenuItem,
  SubMenuItem,
  hasMenuAccess,
  hasMenuAccessOrChild,
  closeMobileSidebar,
  nested = false,
}) {
  if (!hasMenuAccessOrChild('/finance', FINANCE_CHILD_ROUTES)) {
    return null;
  }

  if (nested) {
    return (
      <FinanceFlyoutRow
        SubMenuItem={SubMenuItem}
        hasMenuAccess={hasMenuAccess}
        closeMobileSidebar={closeMobileSidebar}
      />
    );
  }

  return (
    <MenuItem customIcon={<BsCurrencyExchange style={{ width: '24px', height: '24px' }} />} title="Finance" id="finance">
      <FinanceNavContent
        SubMenuItem={SubMenuItem}
        hasMenuAccess={hasMenuAccess}
      />
    </MenuItem>
  );
}
